import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { ReactComponent as Bee } from 'assets/a4bee_bee.svg';

export const BeeButton: React.FC<Omit<IconButtonProps<'a'>, 'href' | 'children'>> = props => (
  <IconButton href='/' {...props}>
    <Bee />
  </IconButton>
);
